import { getToken, handleResponse, nextJsonApi } from '@/API/core';

const notes = {
  fetchNotes: async (refId: number, source: string) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get(
        `/notes?refId=${refId}&source=${source}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  addNote: async (data: {
    ref_id: number;
    source: string;
    note: string;
    company_id?: number | null;
  }) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post('/notes', data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default notes;
